import { RefObject } from "react";

export default (
  horizontalPadding: number,
  verticalPadding: number,
  target: RefObject<HTMLDivElement | HTMLButtonElement | null>,
  source: RefObject<HTMLDivElement | HTMLButtonElement | null>
) => {
  if (!target.current || !source.current) return;
  const maxWidth = document.documentElement.clientWidth - horizontalPadding * 2;
  const maxHeight = document.documentElement.clientHeight - verticalPadding * 2;
  if (!target.current || !source.current) return;
  const ratio = source.current.clientWidth / source.current.clientHeight;
  const vpRatio = maxWidth / maxHeight;
  const letterboxed = vpRatio < ratio;
  const newWidth = letterboxed
    ? maxWidth
    : source.current.clientWidth * (maxHeight / source.current.clientHeight);
  target.current.style.width = newWidth + "px";
};
